import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ConfirmActionPopupData {
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
}

@Component({
  selector: 'vcp-confirm-action-popup',
  templateUrl: './confirm-action-popup.component.html',
  styleUrls: ['./confirm-action-popup.component.scss'],
})
export class ConfirmActionPopupComponent {
  constructor(
    private readonly dialogRef: MatDialogRef<ConfirmActionPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmActionPopupData
  ) {}

  confirm(): void {
    this.dialogRef.close(true);
  }
}
